import { styled, css } from 'styled-components';

import { CssRecord } from '@src/types/utils/styles';

import { HeadingProps } from './types';

type StyleProps = Required<{
  $level: NonNullable<HeadingProps['level']>;
  $centered: HeadingProps['centered'];
  $textTransform: HeadingProps['textTransform'];
}>;

const sizes: CssRecord<StyleProps['$level']> = {
  h1: css`
    font: var(--font-headline-1);
  `,
  h2: css`
    font: var(--font-headline-2);
  `,
  h3: css`
    font: var(--font-headline-3);
  `,
  h4: css`
    font: var(--font-headline-4);
  `,
  h5: css`
    font: var(--font-headline-5);
  `,
};

export const H = styled.h1<StyleProps>`
  ${({ $level }) => sizes[$level]}

  margin: 0;
  text-align: ${({ $centered }) => ($centered ? 'center' : 'initial')};
  text-transform: ${({ $textTransform }) => $textTransform};
`;
